<template>
	<div style="background:#eee;padding: 20px">
	        <Card :bordered="false">
	            <p slot="title">{{data1.title}}</p>11{{data1.type}}
	            <p v-if="data1.type==0" v-html="data1.body"></p>
				
				<iframe v-else style="height: 100vh;width: 100vw;" :src="data1.body"></iframe>
	        </Card>
	    </div>
</template>
<script>
	import echarts from '../api/echarts.js'
	import chinaMap from "@/assets/china.json";
	import moment from 'moment'
	import {
		sendMsg
	} from '../api/index.js'
	export default {
		name: 'hello',
		data() {
			return {
				newsID:34,
				data1:{}
			}
		},
		mounted() {
			this.newsID = this.$route.query.id != undefined && this.$route.query.id != null && this.$route.query.id != '' ?
				this.$route.query.id : 34
			this.initData(this.newsID)	
		},
		
		methods: {
		
			initData(_id){
				sendMsg("/baseNews/selectById", {
					id:_id
				}, 'POST', false).then(res => {
					this.data1 = res.data.result
				})
			}
			
		},
		components: {}
	}
</script>

<style>
</style>
